<template>
  <div class="modal_buy_tariff_packet_item">
    <div class="modal_header">
      <h4 class="title">
        {{ '"' + tariffication_info.tariff_name + '" (' + tariffication_info.date_start + ')' }}
      </h4>
      <p v-if="available_money">
        В этом месяце доступны покупки трафика на {{ available_money }} (USD/EUR)
      </p>
    </div>

    <div v-if="loading" style="height: 100%">
      <div class="spinner">
        <scale-loader/>
      </div>
    </div>


    <div v-else class="modal_info">
      <div class="select">
        <label>
          {{ translate('tariffication.tariff_packet.select_list') }}
        </label>
        <tree-select
            class="notification_select"
            :options="packet_list"
            :placeholder="translate('tariffication.tariff_packet.select_list')"
            v-model="packet_id"
            :searchable="false"
            :clearable="false"
            :multiple="false"
            :max-height="200"
        />
      </div>
      <br>
      <div class="row" v-if="packet_id !== null">
        <div class="row">
          <div class="col-md-4">
            <label> {{ translate('tariffication.tariff_packet.name') }} </label>
            <fg-input
                v-model="packet_info.name"
                :readonly="true"
            />
          </div>

          <div class="col-md-4">
            <label> {{ translate('tariffication.tariff_packet.traffic_limit') }} </label>
            <fg-input v-model="packet_info.traffic_limit"
                      :readonly="true"
            />
          </div>

          <div class="col-md-4">
            <label> {{ translate('tariffication.tariff_packet.cost_for_client') }} </label>
            <fg-input v-model="packet_info.cost"
                      :readonly="true"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <label> {{ translate('traffic_packet_list.mno_base_packet.billing_type') }} </label>
            <fg-input v-model="packet_info.billing_type"
                      :readonly="true"
            />
          </div>

          <div class="col-md-4">
            <label> {{ translate('traffic_packet_list.mno_base_packet.period_type') }} </label>
            <fg-input v-model="packet_info.period_type"
                      :readonly="true"
            />
          </div>
        </div>

        <div class="row">
          <div class="filter checkbox">
            <div class="info">
              {{ translate('tariffication.tariff_packet.unlock_device') }}
            </div>
            <label class="switch" @click.prevent="unblock_device  = !unblock_device ">
              <input type="checkbox" v-model="unblock_device ">
              <span class="slider round"></span>
            </label>
          </div>
        </div>

        <div class="text-center">
          <br>
          <button
              class="btn btn-success btn-fill btn-wd marginButton"
              @click.prevent="buy_packet"
          >
            {{ translate('btn.add') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: "BuyTariffPacketItem",
  props: ['tariffication_info', 'tariffication_id'],

  data() {
    return {
      tariff_packet_item: {},
      available_tariff_packets: {},
      loading: true,
      unblock_device: true,
      packet_id: null,
      available_money: null
    }
  },

  created() {
    this.init()
  },

  computed: {
    packet_info() {
      return this.available_tariff_packets.find((packet) => {
        if (packet.id === this.packet_id) {
          return {...packet}
        }
      });
    },
    packet_list() {
      return this.available_tariff_packets.map((packet) => {
        return {id: packet.id, label: packet.name}
      });
    }
  },

  methods: {
    buy_packet() {
      // console.log('BUY', this.packet_info.id)
      let params = {
        tariffication_id: this.tariffication_id,
        tariff_packet_id: this.packet_info.id,
        unblock_device: this.unblock_device
      }
      this.$http.v1.buyTrafficPacket(params, () => {
        this.$emit("update")
      })
    },
    init() {
      this.$http.v1.getAvailableTrafficPackets(this.tariffication_id, (response) => {
        this.available_tariff_packets = response.data.available_packets
        this.available_money = response.data.client_data.available_money
        this.loading = false
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.modal_buy_tariff_packet_item {
  width: 100%;
  height: auto;
  border-radius: 3px;
  box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
  color: #252422;
  position: relative;
  border: 1px solid #ccc;
  min-height: 85px;
  background-color: #f8f8f8;
  padding: 10px;

  .modal_header {
    text-align: center;

    .title {
      margin-top: 15px;
    }
  }
  .modal_info{
    padding: 10px;
    height: auto;
    min-height: 300px;
  }

  .row {
    margin: 0;
    text-align: left;

    .area {
      margin-bottom: 10px;
    }

    .filter {
      flex-direction: row-reverse;
      justify-content: center;

      .switch {
        margin-right: 10px;
      }
    }
  }
}
</style>
